import client from './client';

export const healthApi = {
  getStatus() {
    return client.get('/health');
  },
};
